import { mobileHeaderNotificationHeightPx } from 'common/constants/ui';

const styles = (theme) => ({
  container: {
    width: '100%',
    zIndex: 100000,
  },
  gridContainer: {
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: mobileHeaderNotificationHeightPx,
    backgroundColor: theme.palette.primary.main,
  },
  closeButton: {
    '&:hover': {
      color: theme.palette.primary.main
    }
  },
  closeIcon: {
    width: '16px',
    height: '16px',
  },
  countdown: {
    height: '40px',
    minWidth: '190px',
    marginRight: '16px',
    fontWeight: 700,
    padding: theme.spacing(0, 2),
    borderColor: '4px',
    borderRadius: '4px',
    color: theme.palette.text.primary,
    backgroundColor: theme.palette.background.main,
  },
});

export default styles;
